




























import Vue from 'vue'

import CTA from '@/component/common/CTA.vue'

export default Vue.extend({
  name: 'Subscribe',
  components: {
    CTA
  },
  data() {
    return {
      email: '',

      store: {
        initial: true,
        success: false,
        error: false,

        hasError: {
          email: false,
          emailInvalid: false
        }
      }
    }
  },
  methods: {
    isvalid(): any {
      if (!this.email) {
        this.store.hasError.email = true
        return false
      }
      if (!this.validMail(this.email)) {
        this.store.hasError.emailInvalid = true
        return false
      }

      return true
    },

    setCommit(): any {
      this.store.initial = true

      this.store.hasError.email = false
      this.store.hasError.emailInvalid = false

      this.store.success = false
      this.store.error = false
    },

    validMail(mail: string): any {
      const expression = /\S+@\S+\.\S+/
      return expression.test(mail)
    },

    subscribe() {
      this.setCommit()

      if (this.isvalid()) {
        const subscribeData = {
          email: this.email
        }

        fetch('https://api.buttondown.email/v1/subscribers', {
          method: 'POST',
          headers: {
            'Authorization': `Token ${process.env.VUE_APP_NEWSLETTER}`,
            'Content-Type': `application/json`
          },
          body: JSON.stringify(subscribeData)
        }).then((data) => {
          this.store.initial = false
          this.store.success = true
        }).catch((error) => {
          this.store.initial = false
          this.store.error = true
        })
      }
    }
  }
})
